import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import API_BASE from "../../config/api";
import PortalDashboard from "./PortalDashboard";

const LenderPortalDashboard = () => {
  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    const createPortalSession = async () => {
      setIsReady(false);
      setError("");

      try {
        const response = await fetch(
          `${API_BASE}/bank-statement-portal/lender-session`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Cookies.get("token")}`,
              Accept: "application/json",
            },
          }
        );
        const json = await response.json();

        if (!isMounted) {
          return;
        }

        if (!response.ok) {
          setError(
            json?.message ||
              "Unable to open the bank statement portal for this lender account."
          );
          return;
        }

        Cookies.set("bank_statement_portal_token", json.token, {
          expires: 365,
        });
        Cookies.set("bank_statement_portal_name", json?.user?.name || "", {
          expires: 365,
        });
        setIsReady(true);
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setError("Unable to open the bank statement portal right now.");
        }
      }
    };

    createPortalSession();

    return () => {
      isMounted = false;
    };
  }, []);

  if (error) {
    return (
      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "560px",
            padding: "24px",
            borderRadius: "8px",
            background: "white",
            border: "1px solid rgba(18,48,74,0.08)",
            boxShadow: "0 14px 40px rgba(18,48,74,0.08)",
            color: "#12304a",
            fontFamily: "Manrope, sans-serif",
          }}
        >
          <div style={{ fontSize: "20px", fontWeight: 800 }}>
            Bank statement portal unavailable
          </div>
          <div
            style={{
              marginTop: "10px",
              color: "#617487",
              fontSize: "14px",
              lineHeight: 1.5,
            }}
          >
            {error}
          </div>
        </div>
      </div>
    );
  }

  if (!isReady) {
    return (
      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#12304a",
          fontFamily: "Manrope, sans-serif",
          fontWeight: 800,
        }}
      >
        Opening bank statement portal...
      </div>
    );
  }

  return <PortalDashboard key="lender-portal-dashboard" />;
};

export default LenderPortalDashboard;
